module.exports = __webpack_public_path__ + "img/arquitetura_e_decoracao.ec670af0.svg";